import { useOrgPostVariantFeedStore } from "SmartFeed/stores/feed/org-post-variant-feed-store";
import { useMyPostEntityStore } from "SmartFeed/stores/entity/my-post-entity-store";
import { usePublicationStore } from "@/stores/publication-store";
import { defineStore } from "pinia";

export const useStoryVariantStore = defineStore("story-variant-store", {
  state: () => ({
    variants: [],
    variantNames: {},
    storyId: 0,
  }),
  getters: {
    variantFeedData() {
      const results = [];
      const entities = useMyPostEntityStore().entities;
      let entityIds = Object.keys(entities);
      useOrgPostVariantFeedStore().feed.forEach(entity => {
        if (entityIds.includes(entity.id.toString())) {
          const finalEntity = entities[entity.id];
          if (this.storyId !== entity.id && finalEntity !== undefined) {
            finalEntity["variantId"] = entity.id;
            results.push(finalEntity);
          }
        }
      });
      return results;
    },
  },
  actions: {
    async getPublicationName(variant) {
      return await usePublicationStore().fetchPublication(variant.publishingPlatformId).then(publication => {
        return this.variantNames[variant.variantId] = publication.name;
      });
    },
    getVariantName(variant) {
      if (variant.variantType === "PUBLICATION") {
        if (variant.publishingPlatformId > 0) {
          this.getPublicationName(variant);
        }
      }

      return variant.storyTitle;
    },
    updateVariantNames() {
      this.variantFeedData.forEach(variant => {
        this.variantNames[variant.variantId] = this.getVariantName(variant);
      });
    },
    async fetchVariants() {
      useOrgPostVariantFeedStore().metadata.parentId = this.storyId;
      await useOrgPostVariantFeedStore().getSmartFeed();
    },
    getIcon(variantType) {
      if (variantType.includes("_post")) {
        variantType = variantType.replaceAll("_post", "").toUpperCase();
      }
      switch (variantType) {
        case "X":
          return "x";
        case "LINKEDIN":
          return "linkedin";
        case "INSTAGRAM":
          return "instagram";
        case "FACEBOOK":
          return "facebook";
        case "YOUTUBE":
          return "youtube";
        case "PINTEREST":
          return "pinterest";
        case "TIKTOK":
          return "tiktok";
        case "BLUESKY":
          return "bluesky";
        case "PUBLICATION":
          return "logo";
        case "EMAIL":
          return "envelope-open-text";
        case "CONCEPT":
          return "icon-park:concept-sharing";
        case "OUTLINE":
          return "mdi:format-list-bulleted";
        default:
          return "logo";
      }
    },
    getVariantTypeBySocialNetworkName(socialNetworkName) {
      if (socialNetworkName === "Twitter") {
        socialNetworkName = "X";
      }

      return socialNetworkName.toLowerCase() + "_post";
    },
    getVariantTypeName(variantType) {
      switch (variantType) {
        case "X":
          return "X Post";
        case "LINKEDIN":
          return "Linkedin Post";
        case "INSTAGRAM":
          return "Instagram Post";
        case "BLUESKY":
          return "BlueSky Post";
        case "SYNDICATION_MARKETPLACE":
          return "Syndication Marketplace Story";
        case "PUBLICATION":
          return "Publication";
        default:
          return "Newsletter";
      }
    },
  },
});
